import { Component, ViewEncapsulation, input } from '@angular/core';
import { ButtonVariant } from '../../atoms/button/button';
import { LinkComponent } from '../../atoms/link/link';

export type CtaVariant = 'dark' | 'light';

export interface CtaAction {
  label: string;
  href: string;
  variant: ButtonVariant;
}

@Component({
  selector: 'ds-cta-block',
  templateUrl: './cta-block.html',
  styleUrl: './cta-block.scss',
  encapsulation: ViewEncapsulation.None,
  imports: [LinkComponent],
})
export class CtaBlockComponent {
  readonly variant = input<CtaVariant>('dark');
  readonly heading = input.required<string>();
  readonly subtitle = input('');
  readonly actions = input<CtaAction[]>([]);
  readonly escapeText = input('');
  readonly escapeHref = input('');
}
